import { ColorHues } from "@chakra-ui/react";

/**
 * Generated via https://lyft-colorbox.herokuapp.com/
 */
export const PrimaryColors: ColorHues = {
    50: "#95B7FF",  // Light sky blue
    100: "#6598FD",  // Medium sky blue
    200: "#3B7EF9",  // Bright blue
    300: "#1565F2",  // Vibrant blue
    400: "#0456E9",  // Deep blue
    500: "#0451DD",  // Primary blue
    600: "#0347CD",  // Darker blue
    700: "#033BB8",  // Very dark blue 
    800: "#032DA0",  // Extremely dark blue 
    900: "#022487",  // Darkest blue
};

export const PrimaryDarkColors: ColorHues = {
    50: "#F5F5F5",
    100: "#F0EEEE",
    200: "#ECE7E7",
    300: "#D5CCCD",
    400: "#706868",
    500: "#807777",
    600: "#50494A",
    700: "#2A2727",
    800: "#131212",
    900: "#0A0909",
};
